import { defineNuxtPlugin } from '#app';
import type { IParentAds } from '@shared/ads-modules';
import { useI18n } from 'vue-i18n';

export default defineNuxtPlugin((nuxtApp) => {
   

    nuxtApp.provide('productUrl', (item: IParentAds) => {
        
        const { locale } = useI18n(); // Move useI18n() inside the plugin function
        let url = `/product/${item?.id}`;
        const params = new URLSearchParams();

        if (item?.adsCategory?.id) {
            params.append('category', item.adsCategory.id);
            params.append('categoryName', item.adsCategory.name[locale.value]);
        }
        if (item?.adsType?.id) {
            params.append('adsType', item.adsType.id);
            params.append('adsTypeName', item.adsType.name[locale.value]);
        }
        if (item?.adsSubchapter?.id) {
            params.append('subchapter', item.adsSubchapter.id);
            params.append('subchapterName', item.adsSubchapter.name[locale.value]);
        }

        const queryString = params.toString();

        return queryString ? `${url}?${queryString}` : url;
    });
});
